import React, { useEffect, useState } from 'react';
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import { decryptToken } from '../../../helpers/helpers';
import {
  clearAll,
  onOnboardUser,
  setErrorMessage,
  setLoading
} from "../../../config/redux/slice/authSlice";
import { postRequest } from '../../../helpers/request';
import { appApi } from '../../../utils/endpoints/appApi';
import { appUrls } from '../../../utils/urls/appUrls';
import { AuthAlert, Spinner } from '../../components';
import LinkVerificationErrorComponent from './LinkVerificationErrorComponent';
import LinkVerificationSuccessComponent from './LinkVerificationSuccessComponent';
import AuthFormWrapper from '../../layout/AuthFormWrapper';

export default function AccountActivation() {
  const dispatch = useDispatch()
  const {encryted_email} = useParams()
  const {register, handleSubmit, formState: {errors}} = useForm({mode: 'onTouched'})

  const [successMessage, setSuccessMessage] = useState(false)

  const {
        loading,
        errorMsg,
    } = useSelector((state) => state.authData)

    useEffect(()=>{
      dispatch(clearAll({}))
      verifyEmail()
    }, [])

    const verifyEmail = async () => {
      let email = decryptToken(encryted_email)
        dispatch(clearAll({}))
        setSuccessMessage(false)
        const res = await postRequest(
            "",
            `${appApi.verify_email}`,
            {token: encodeURIComponent(encryted_email)},
            dispatch,
            setLoading,
            "",
            setErrorMessage
        )
        if(res !== undefined && res.status < 400){
            setSuccessMessage(true)
        }
        dispatch(onOnboardUser({email}))
    }

  return (
    <>
      {
        successMessage && 
        <LinkVerificationSuccessComponent
          formTitle='Account Successfully Activated!'
          activationMessage='Congratulations! Your account has been 
             successfully activated. You can now proceed to login'
        /> }
        { errorMsg && <LinkVerificationErrorComponent
          formTitle='Account Activation Error'
          activationMessage={errorMsg}
        />
      }
    </>
  )
}
